import { render, staticRenderFns } from "./TagProcessor.vue?vue&type=template&id=84916c30&scoped=true"
import script from "./TagProcessor.vue?vue&type=script&lang=js"
export * from "./TagProcessor.vue?vue&type=script&lang=js"
import style0 from "./TagProcessor.vue?vue&type=style&index=0&id=84916c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84916c30",
  null
  
)

export default component.exports